module.exports = __webpack_public_path__ + "img/gm1.d6fec79a.png";